document.addEventListener('DOMContentLoaded', function () {
    const ContentModalPackaing = document.querySelector('.content-modal-packaing');
    if (ContentModalPackaing) {
        const OpenModalPackaing = document.querySelector('.open-modal');
        if (OpenModalPackaing) {
            OpenModalPackaing.addEventListener('click', (e) => {
                e.preventDefault();

                ContentModalPackaing.classList.add('open');
            });
        }

        const CloseModalPackaing = document.querySelector('.icon-close');
        if (CloseModalPackaing) {
            CloseModalPackaing.addEventListener('click', () => {
                ContentModalPackaing.classList.remove('open');
            });
        }
    }

})